<template>
  <v-card class="mx-auto d-flex flex-column" :width="showExternalContent ? null : 375" :height="showExternalContent ? null : 300" :style="outerStyle">
    <div ref="innerSpace">
      <BackButton v-if="showBackButton" @click="onBackButtonClick" />
      <div v-if="isCard(params.methodTypeId)" class="pageTitle mb-3">{{$t('pay_by_card')}}</div>
      <div v-else-if="isPISP(params.methodTypeId)" class="pageTitle mb-3">{{$t('online_wire_transfer')}}</div>
      <loader v-if='!showExternalContent' class="loader-component" :color="'#062127'"/>
    </div>
    <iframe v-if='showExternalContent' ref="iframe" name="paiExtContent" :style="innerStyle" :src='params.redirectUrl' @load="onLoad"/>
  </v-card>
</template>

<script>
import { VCard } from 'vuetify/lib'
import BackButton from '@/components/BackButton'
import Loader from '@/components/Loader.vue'
import RequestHandler from '../../mixins'
import valueMappings from '@/mixins/valueMappings'
import testData from './testData'
import { mapState } from 'vuex'

export default {
  name: 'PaymentRedirect',
  components: { VCard, BackButton, Loader } ,
  mixins: [RequestHandler, valueMappings],
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    origin: {
      type: String,
      default: ''
    }
  },
  created: function () {
    let info = this.params
    if (info.endInd === true) {
      this.showExternalContent = false  
      this.getPaymentResult()
    }
    else {
      this.showExternalContent = true
    }
  },
  mounted: function () {
    if (this.$refs.innerSpace) {
      this.innerSpace = this.$refs.innerSpace.clientHeight
    }
  },
  computed: {
    ...mapState(['singlePaymentMethod']),
    fixedIframeHeight: function () {
      return this.params && this.params.frameHeight
    },
    fixedIframeWidth: function () {
      return this.params && this.params.frameWidth
    },
    outerStyle: function () {
      let style = {}
      if (!this.fixedIframeHeight) style.height = 'calc(100vh - 30px)'
      else style.height = (Number(this.params.frameHeight) + 48 + this.innerSpace) + 'px'
      if (this.fixedIframeWidth) style.width =Number(this.params.frameWidth) + 'px'
      return style
    },
    innerStyle: function () {
      let style = {
        marginLeft: '-24px',
        marginRight: '-24px'
      }
      if (!this.fixedIframeHeight) style.height = 'calc(100vh - 80px)'
      else style.height = this.params.frameHeight + 'px'
      // if (this.fixedIframeWidth) style.width = Number(this.params.frameWidth) + 'px'

      return style
    },
    showBackButton () {
      return false
      // return !this.singlePaymentMethod || this.params.aliasStep !== '0'
    }
  },
  methods: {
    onLoad () {
      try {
        let url = this.$refs.iframe.contentWindow.location.href
        if (url) {
          let sp = new URLSearchParams(this.$refs.iframe.contentWindow.location.search)
          for (let pair of sp.entries()) {
            this.params.detail[pair[0]] = pair[1]
          }
          this.getPaymentResult()
        }
      } catch (err) {
        console.log(err)
      }
    },
    onBackButtonClick: function () {
      if (this.isSDD(this.params.methodTypeId)) this.$emit('goBack')
      else this.$emit('abort')
    },
    getPaymentResult () {
      this.callPaymentResult(this.params.detail).then(rep => {
        if (!rep) throw new Error(this.$t('error_paymentresult'))
        this.stopLoader()
        const content = rep.content
        if (content.statusCode === '0') {
          this.$emit('paymentResultCalled', content)
        }
        else if (process.env.NODE_ENV !== 'production') this.$emit('paymentResultCalled', testData.startPaymentEnd2)
      })
      .catch(err => {
        this.stopLoader()
        this.setFatalError({ description: this.$t(err.message)})
      })
    },
    stopLoader () {
      this.$emit('stopLoader')
    },
    startLoader () {
      this.$emit('startLoader')
    }
  },
  data: function () {
    return {
      showExternalContent: false,
      windowHeight: 0,
      innerSpace: 0
    }
  }
}
</script>

<style scoped>
  iframe {
    border: unset;
  }

.loader-component {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  z-index: 2000;
}
</style>
